import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap'; import ReusableButton from '../button';
;

const Checkout = ({ cartProducts }) => {
    const [show, setShow] = useState(false);

    const showModal = () => {
        setShow(true);
    }

    const checkOut = () => {
        //action
        setShow(false)
    }

    const cancelCheckout = () => {
        //action
        setShow(false)
    }

    const totalPay = cartProducts.reduce((total, current) => {
        //converting price string into number
        const productPrice = Number(current.newPrice.slice(0, -1));
        //the user has the option to buy the product by any quantity
        return total + productPrice * current.quantity;
    }, 0);

    return (
        cartProducts.length ?
            <div className="check-out text-center py-3">
                <p className="text-white font-size-md">Total: {totalPay.toFixed(2)}$</p>
                <ReusableButton
                    classes={{
                        btn: 'check-out-btn bg-dark my-2 mr-3'
                    }}
                    type="submit"
                    text="Check Out"
                    label="check-out"
                    onClick={showModal}
                />
                <Modal show={show}>
                    <Modal.Header>
                        <Modal.Title>
                            Are You Sure You Want To Check Out ?
                    </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="checkout-modal-body">
                        <Button
                            variant="primary"
                            className="ok"
                            onClick={checkOut}
                        >Ok</Button>
                        <Button
                            variant="danger"
                            className="cancel"
                            onClick={cancelCheckout}
                        >Cancel</Button>
                    </Modal.Body>
                </Modal>
            </div> : ''
    )
}

export default Checkout;
